import { SchemaCRUD } from '@/components/crud/SchemaCRUD';

const Roles = () => {
	return (
		<SchemaCRUD
			entity="roles"
			title="Papéis (Roles)"
			description="Gerenciar papéis e permissões do sistema"
			apiEndpoint="v1/admin/roles"
		/>
	);
};

export default Roles;
